import type { ReactNode } from "react";
import { Trans, useTranslation } from "react-i18next";

import { Link, Separator, Spacer, Typography } from "@aviary";
import { l } from "@shared/locales/i18n";

import { ResendOtp } from "../../components/ResendOtp/ResendOtp";

import * as styles from "./EnableWithSMS.styles";

interface Props {
  phoneLast4: string;
  children: ReactNode;
  isVerifyChangeFlow?: boolean;
  isModal?: boolean;
}

const EnableWithSMS = ({ phoneLast4, children, isVerifyChangeFlow, isModal }: Props) => {
  const { t } = useTranslation();

  const renderTitle = () => {
    if (isVerifyChangeFlow) {
      return null;
    }

    if (isModal) {
      return (
        <>
          <Typography type="h4">{t(l.mfa.enableWithSMS.title)}</Typography>
          <Typography isMarginless>{t(l.mfa.enableWithSMS.subtitle)}</Typography>
          <Typography>
            <Link
              isColor="system"
              href="https://support.fullscript.com/articles/securing-your-practitioner-account-with-multi-factor-verification/#enabling-multi-factor-authentication-sms-option"
            >
              {t(l.sharedCommon.learnMore)}
            </Link>
          </Typography>
          <Spacer height="one" />
        </>
      );
    }

    return (
      <div css={styles.header}>
        <Typography type="h1">{t(l.mfa.enableWithSMS.title)}</Typography>
      </div>
    );
  };

  return (
    <>
      {renderTitle()}
      <Typography isSecondaryWeight isMarginless>
        {t(l.mfa.step1)}
      </Typography>
      <Typography>
        <Trans i18nKey={l.mfa.enableWithSMS.codeSentToMobileNumber} values={{ phoneLast4 }} />
      </Typography>
      <ResendOtp phoneLast4={phoneLast4} isVerifyChangeFlow={isVerifyChangeFlow} />
      <Separator css={styles.separator} />
      <Typography isSecondaryWeight isMarginless>
        {t(l.mfa.step2)}
      </Typography>
      <Typography>{t(l.mfa.enableWithSMS.enterCodeFromSms)}</Typography>
      {children}
      <Spacer height="one" />
    </>
  );
};

export { EnableWithSMS };
